import { render, staticRenderFns } from "./CasesList.vue?vue&type=template&id=3bdcaa42&scoped=true"
import script from "./CasesList.vue?vue&type=script&lang=js"
export * from "./CasesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdcaa42",
  null
  
)

export default component.exports